import {makeAutoObservable} from 'mobx';

import type {YcTable} from '../types';

export class TableState implements YcTable.State {
  columnFilters: YcTable.ColumnFiltersState = [];
  sorting: YcTable.SortingState = [];

  constructor() {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  init(state?: YcTable.State): TableState {
    if (state) {
      this.setSorting(state.sorting);
      this.setColumnFilters(state.columnFilters);
    }

    return this;
  }

  setColumnFilters(columnFilters: YcTable.ColumnFiltersState) {
    this.columnFilters = columnFilters;

    return this;
  }

  setSorting(sorting: YcTable.SortingState) {
    this.sorting = sorting;

    return this;
  }
}
